// SidebarMenu.js

import React, { useEffect, useState } from "react";
import { gql } from "@apollo/client";
import { client } from "../../../client";

import Button from "@mui/material/Button";

import ModifyDocument from "./ModifyDocument";

// DataGrid

import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Box } from "@mui/material";

const SEARCH_DOCU_LIST = gql`
  query searchDocuType($document_search_input: document_search_input) {
    searchDocuType(document_search_input: $document_search_input) {
      id
      docu_type1_name
      docu_type1_id
      docu_type2_name
      docu_type2_id
      name
      price
      grade
      year
      month_id
      subject
      publisher_id
      category1_id
      category2_id
      object_url
      document_url_id
    }
  }
`;

const DocuType1Page = () => {
  const [documentList, setDocumentList] = useState([]);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);

  // Tab
  const fetch = () => {
    client
      .query({
        query: SEARCH_DOCU_LIST,
        variables: {
          document_search_input: {
            page: 1,
            pageSize: 100,
          },
        },
      })
      .then((res) => {
        setDocumentList(res.data.searchDocuType);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    console.log("가져옵니다...");
    fetch();
  }, []);

  // const userList = data.getUserListByAdmin;
  const handleEditClick = (document) => {
    setSelectedDocument(document);
    setModalOpen(!isModalOpen);
  };

  const handleDeleteClick = async (document) => {
    const isConfirmed = window.confirm("정말 삭제하시겠습니까?");

    if (isConfirmed) {
    }
    const DELETE_DOCU = gql`
      mutation deleteDocument($document_id: Int) {
        deleteDocument(document_id: $document_id)
      }
    `;

    try {
      const res = await client.mutate({
        mutation: DELETE_DOCU,
        variables: {
          document_id: document.id,
        },
        fetchPolicy: "no-cache",
      });
      alert("삭제하였습니다.");
      window.location.reload(true);
    } catch (err) {
      console.log(err);
    }
  };

  const handleCloseClick = () => {
    setModalOpen(false);
  };

  // Tab

  const handleSearchDocuType = (docu_type1_id) => {
    client
      .query({
        query: SEARCH_DOCU_LIST,
        variables: {
          document_search_input: {
            docu_type1_id: docu_type1_id,
            page: 1,
            pageSize: 100,
          },
        },
      })
      .then((res) => {
        console.log(res);
        setDocumentList(res.data.searchDocuType);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // DataGrid

  const columns = [
    { field: "id", headerName: "ID", flex: 1 },
    { field: "name", headerName: "자료명", flex: 1 },
    { field: "docu_type2_name", headerName: "자료 유형", flex: 1 },
    { field: "subject", headerName: "과목", flex: 1 },
    { field: "grade", headerName: "학년", flex: 1 },
    { field: "year", headerName: "연도", flex: 1 },
    { field: "month_id", headerName: "월", flex: 1 },
    { field: "price", headerName: "가격", flex: 1 },
    { field: "object_url", headerName: "objUrl", flex: 3 },
    {
      field: "edit",
      headerName: "자료 수정",
      flex: 1,
      renderCell: (params) => (
        <Button onClick={() => handleEditClick(params.row)}>수정</Button>
      ),
    },
    {
      field: "delete",
      headerName: "자료 삭제",
      flex: 1,
      renderCell: (params) => (
        <Button onClick={() => handleDeleteClick(params.row)}>삭제</Button>
      ),
    },
  ];

  const tabOptions = [
    { text: "모의고사/학평", value: "모의고사/학평", docu_type1_id: 1 },
    {
      text: "고등 부교재 (EBS 교재)",
      value: "고등 부교재 (EBS 교재)",
      docu_type1_id: 2,
    },
    {
      text: "수능연계교재(수능특강, 수능완성)",
      value: "수능연계교재(수능특강, 수능완성)",
      docu_type1_id: 3,
    },
    { text: "고등교과서", value: "고등교과서", docu_type1_id: 4 },
  ];

  return (
    <div>
      <Box
        margin={"7px"}
        display={"flex"}
        height={"70px"}
        justifyContent={"space-between"}
      >
        <Box ml={"5px"}>
          <h4>자료 관리</h4>
        </Box>
      </Box>

      <Box>
        {tabOptions.map((option) => (
          <Button
            key={option.value}
            onClick={() => handleSearchDocuType(option.docu_type1_id)}
          >
            {option.text}
          </Button>
        ))}
      </Box>

      <Box ml={"5px"}>
        <DataGrid
          rows={documentList}
          columns={columns}
          initialState={{
            pagination: { paginationModel: { pageSize: 20 } },
          }}
          pageSizeOptions={[10, 20, 30]}
          components={{
            Toolbar: () => <GridToolbar />,
          }}
        />
      </Box>

      {/* Modal for Edit */}
      {/* 모달 새로만들기 */}

      <ModifyDocument
        isOpen={isModalOpen}
        handleCloseClick={handleCloseClick}
        data={selectedDocument}
      ></ModifyDocument>
    </div>
  );
};

export default DocuType1Page;
